import { InjectionToken } from '@angular/core';

export interface AppVersion {
    version: string | null | undefined;
    tag: string | null | undefined;
    commitHash: string;
    branchName: string;
    timestamp: string;
}

export const AppVersionInstanceToken = new InjectionToken<AppVersion>('AppVersion');
